import React, { useEffect, useState } from 'react';

import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import AssetListItem from '../../../Valuations/AssetList/assetListItem';
import CircularProgress from '@mui/material/CircularProgress';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ListAltIcon from '@mui/icons-material/ListAlt';
import Typography from '@mui/material/Typography';
import { VALUATIONS_PATH } from '../../../../utils/constants';
import { WATCH_LIST_QUERY } from './operations';
import { useTutorialContext } from '../../../../contexts/TutorialContext';
import makeStyles from '@mui/styles/makeStyles';
import { useHistory } from 'react-router-dom';
import { useQuery } from '@apollo/client';

const useStyles = makeStyles((theme) => ({
  details: {
    padding: 0,
  },
  layersAccordion: {
    display: 'flex',
    flexDirection: 'column',
  },
  label: {
    [theme.breakpoints.down('lg')]: {
      fontSize: '10px',
    },
    fontWeight: 'bold',
  },
}));

export default () => {
  const classes = useStyles();
  const history = useHistory();
  const { tutorial } = useTutorialContext();

  const [expanded, setExpanded] = useState(true);

  const { loading, data } = useQuery(WATCH_LIST_QUERY);

  const setAsset = (asset) => {
    history.push(`${VALUATIONS_PATH}/${asset.country.isoCode}/${asset.legacyId}`);
  };

  useEffect(() => {
    if (tutorial) {
      setExpanded(false);
    } else {
      setExpanded(true);
    }
  }, [tutorial]);

  return (
    <Accordion
      id="watchlist-accordion"
      square={true}
      expanded={expanded}
      onChange={(e, exp) => setExpanded(exp)}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel-layers">
        <ListAltIcon fontSize="small" />
        &nbsp;&nbsp;
        <Typography className={classes.label} variant="caption">
          WATCHLIST
        </Typography>
      </AccordionSummary>
      <AccordionDetails className={classes.details}>
        {loading ? (
          <CircularProgress color="inherit" size={20} />
        ) : (
          <div className={classes.assetListItemsContainer}>
            {data.watchList?.map((asset) => (
              <AssetListItem
                key={asset.displayName}
                asset={asset}
                setAsset={setAsset}
                isSelected={false}
                isWatchList={true}
                sortType={{ filter: 'name' }}
              />
            ))}
          </div>
        )}
      </AccordionDetails>
    </Accordion>
  );
};
